// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3syy9","title":"Info_title__29Yfw","selects":"Info_selects__2Zg0D","requiredAsterisk":"Info_requiredAsterisk__3nhk3"};